import { render, staticRenderFns } from "./CompTextImageFullWidth.vue?vue&type=template&id=5e86bf6f"
import script from "./CompTextImageFullWidth.vue?vue&type=script&lang=js"
export * from "./CompTextImageFullWidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports